import { Component } from '@angular/core';

@Component({
    selector: 'loading-screen',
    templateUrl: './loading-screen.component.html',
    styleUrls: ['./loading-screen.component.css'],
    standalone: false
})
export class LoadingScreenComponent {

}
